import React from 'react'
import ProgressBarComponent from './progress-bar.component'
import { connect } from 'react-redux'
import { scrollToTop } from '../../helpers/window.helper'
import { Creators as ProgressBarCreators } from '../../ducks/progress-bar/progress-bar'

function ProgressBarContainer({ current, setCurrent, items }) {
	const nextStep = () => {
		setCurrent(Math.min(items.length, current + 1))
		scrollToTop()
	}

	const previousStep = () => {
		setCurrent(Math.max(0, current - 1))
		scrollToTop()
	}

	const percent = (current * 100) / (items.length - 1)

	return (
		<ProgressBarComponent
			{...{
				items,
				current,
				percent,
				nextStep,
				setCurrent,
				previousStep
			}}
		/>
	)
}

const mapStateToProps = ({ progressBar: { current } }) => ({
	current
})

const mapDispatchToProps = {
	setCurrent: ProgressBarCreators.setCurrent
}

const ProgressBar = connect(
	mapStateToProps,
	mapDispatchToProps
)(ProgressBarContainer)

export default ProgressBar
